import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { AuthProvider } from "@theg1group/rbac-ui";
import { ToastProvider } from "@theg1group/ui";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App } from "./App";
import { clearTokens } from "./lib/auth";
import { fetchMe } from "./lib/me";
import "./index.css";

const queryClient = new QueryClient({
	defaultOptions: { queries: { retry: 1, staleTime: 30_000 } },
});

const root = document.getElementById("root");
if (!root) throw new Error("root element missing");

createRoot(root).render(
	<StrictMode>
		<QueryClientProvider client={queryClient}>
			<ToastProvider>
				<BrowserRouter>
					<AuthProvider
						fetchUser={fetchMe}
						onLogout={() => {
							clearTokens();
							location.href = "/";
						}}
					>
						<App />
					</AuthProvider>
				</BrowserRouter>
			</ToastProvider>
		</QueryClientProvider>
	</StrictMode>,
);
